import { useRouter } from 'vue-router';
import { RouteNames } from '@/core/plugins/router/routeNames';

export const userFaq = () => {
  const $router = useRouter();

  const usersRoute = $router.resolve({ name: RouteNames.Users });

  const objectsRoute = $router.resolve({ name: RouteNames.Home });

  const profileRoute = $router.resolve({ name: RouteNames.Profile });

  const documentsRoute = $router.resolve({ name: RouteNames.Documents });

  const faq = [
    {
      sectionTitle: 'Пользователи и&nbsp;доступ',
      questions: [
        {
          question: 'Как добавить нового пользователя в&nbsp;своё пространство?',
          answer: `Администратор может отправить ссылку-приглашение из&nbsp;раздела <a href="${usersRoute.href}" class="link"> Пользователи</a>. Укажите e-mail и&nbsp;роль нового участника.`,
        },
        {
          question: 'Как изменить права пользователя?',
          answer: `В&nbsp;разделе <a href="${usersRoute.href}" class="link"> Пользователи</a> выберите нужного пользователя &rarr; измените его роль в&nbsp;пространстве.`,
        },
        {
          question: 'Как удалить пользователя?',
          answer: `В&nbsp;разделе <a href="${usersRoute.href}" class="link"> Пользователи</a> выберите нужного пользователя &rarr; нажмите на&nbsp;три точки &rarr; нажмите &laquo;Удалить&raquo;. Действия доступны Владельцу и&nbsp;Администратору.`,
        },
        {
          question: 'Могу&nbsp;ли я&nbsp;переключаться между разными договорами?',
          answer: `Да. В&nbsp;личном кабинете доступна кнопка переключения между аккаунтами (договорами) в&nbsp;разделе <a href="${objectsRoute.href}" class="link"> Объекты размещения</a> или на&nbsp;странице&nbsp;ОР.`,
        },
        {
          question: 'Как поменять контактные данные?',
          answer: `В&nbsp;личном кабинете откройте <a href="${profileRoute.href}" class="link"> Профиль</a> и&nbsp;отредактируйте данные. E-mail недоступен для редактирования, так как он&nbsp;является вашим логином для авторизации (при необходимости смены e-mail просьба повторно зарегистрироваться в&nbsp;Экстранет).`,
        },
      ],
    },
    {
      sectionTitle: 'Объекты размещения',
      questions: [
        {
          question: 'Как добавить описание отеля?',
          answer:
            'Перейдите в&nbsp;раздел &laquo;Контент&raquo; объекта и&nbsp;измените тексты, фото, категории номеров, услуги.',
        },
        {
          question: 'Как добавить категорию номера?',
          answer:
            'В&nbsp;карточке&nbsp;ОР откройте &laquo;Категории номеров&raquo; &rarr; нажмите &laquo;Добавить&raquo; &rarr; заполните параметры.',
        },
        {
          question: 'Как указать график заселения и&nbsp;правила аннуляции?',
          answer:
            'При создании тарифного плана в&nbsp;общих настройках для указания графика заселения есть соответствующий блок: &laquo;Расчётные часы&raquo;. Правило аннуляции (штрафования) в&nbsp;Экстранете ограничено одним доступным значением.',
        },
        {
          question: 'Как отредактировать или скрыть объект размещения?',
          answer: 'Редактирование или скрытие с&nbsp;витрины выполняется через обращение в&nbsp;поддержку.',
        },
      ],
    },
    {
      sectionTitle: 'Тарифы, квоты, бронирования',
      questions: [
        {
          question: 'Как создать новый тарифный план?',
          answer:
            'Через раздел &laquo;Тарифные планы&raquo; можно создать ручной тариф или подключить менеджер каналов.',
        },
        {
          question: 'Как редактировать существующий тариф?',
          answer:
            'Нажмите на&nbsp;тариф &rarr; Откройте нужный подраздел &rarr; Редактируйте. После отправки тарифа на&nbsp;модерацию нельзя редактировать основную информацию и&nbsp;созданные ранее Группы услуг.',
        },
        {
          question: 'Где управлять квотами ручного тарифа?',
          answer:
            'Внутри тарифного плана есть блок &laquo;Квоты номеров&raquo;, где задаются периоды и&nbsp;количество номеров.',
        },
        {
          question: 'Как подтвердить или отменить бронирование?',
          answer:
            'Откройте карточку бронирования в&nbsp;разделе &laquo;Бронирования&raquo;. Доступны кнопки &laquo;Подтвердить&raquo; или &laquo;Отклонить&raquo;. Обратите внимание, что кнопки доступны только до&nbsp;заезда.',
        },
      ],
    },
    {
      sectionTitle: 'Документы и договоры',
      questions: [
        {
          question: 'Где скачать акты, отчёты и другие документы?',
          answer: `Перейдите в&nbsp;раздел <a href="${documentsRoute.href}" class="link"> Документы</a>, выберите тип и&nbsp;скачайте PDF.`,
        },
        {
          question:
            'Можно&nbsp;ли работать с&nbsp;несколькими&nbsp;юр. лицами в&nbsp;рамках одного Объекта размещения?',
          answer:
            'Да. В&nbsp;одном&nbsp;ОР можно управлять несколькими юридическими лицами одновременно через разные аккаунты (договоры).',
        },
        {
          question: 'Как подписать договор оферты?',
          answer: 'При создании аккаунта заполняется и&nbsp;подписывается договор оферты.',
        },
      ],
    },
    {
      sectionTitle: 'Поддержка и уведомления',
      questions: [
        {
          question: 'Как обратиться в&nbsp;техподдержку?',
          answer:
            'С&nbsp;помощью онлайн-чата, по&nbsp;телефону или&nbsp;эл. почте в&nbsp;разделе &laquo;Поддержка&raquo;',
        },
        {
          question: 'Я&nbsp;не&nbsp;получаю письма от&nbsp;Экстранет. Что делать?',
          answer:
            'Проверьте папку &laquo;Спам&raquo;. Если проблема сохраняется&nbsp;&mdash; напишите в&nbsp;поддержку.',
        },
      ],
    },
  ];

  return { faq };
};
